<template>
  <JobNotes
    v-if="appointment.job?.id"
    :commentable-id="appointment.job.id"
    @refresh="emit('refresh-appointment')"
  />
</template>

<script setup lang="ts">
import { AppointmentV2 } from "@/typings/appointment";
import JobNotes from "./JobNotes.vue";

const emit = defineEmits(["refresh-appointment"]);
defineProps<{ appointment: AppointmentV2 }>();
</script>

<style scoped></style>
